import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Link, match } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { TypologyForm } from 'types';
import Layout from '../../components/templates/layout';
import { useIntl } from '../../common/config/i18n';
import {
  TypologyActions,
  OtherSelectionSelectors,
  TypologySelectors,
  ClearStateSliceActions,
} from '../../common/config/store';
import history from '../../app-router/history';
import FormTypology from '../../components/templates/form-typology';
import Card from '../../components/molecules/card';

const Wrapper = styled.div`
  margin: 5px;
`;
const StyledBreadcrumbWrapper = styled.div`
  margin: 10px 0 20px 20px;
`;
interface Props {
  match: match<Params>;
}
interface Params {
  id: string;
}
const TypologyPage: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const { t } = useIntl();
  const { id } = props.match.params;
  const typologyId = Number(id);
  const status = useSelector(TypologySelectors.statusSelector);
  const error = useSelector(TypologySelectors.errorSelector);

  useEffect(() => {
    return () => {
      dispatch(ClearStateSliceActions.clearStateSlice({ sliceReducer: 'Typology', sliceKey: 'error' }));
      dispatch(ClearStateSliceActions.clearStateSlice({ sliceReducer: 'Typology', sliceKey: 'status' }));
    };
  }, [dispatch]);

  const onSubmitHandler = (values: TypologyForm) => {
    if (typologyId) {
      dispatch(
        TypologyActions.updateTypology(
          {
            ...values,
            id: typologyId,
          },
          (result) => {
            if (!result.cancelled && !result.error) {
              history.push('/typologies');
            }
          }
        )
      );
    } else {
      dispatch(
        TypologyActions.createTypology(values, (result) => {
          if (!result.cancelled && !result.error) {
            history.push('/typologies');
          }
        })
      );
    }
  };
  const title = typologyId ? t('TypologyPage', 'TYPOLOGY_UPDATE') : t('TypologyPage', 'TYPOLOGY_CREATE');
  const typologies = useSelector(OtherSelectionSelectors.typologiesSelector);
  const typology = typologyId ? typologies.find((typo) => typo.id === typologyId) : undefined;

  return (
    <div>
      <Layout />
      <Wrapper>
        <StyledBreadcrumbWrapper>
          <Link to="/typologies">{t('TypologyPage', 'TYPOLOGY_BACK')}</Link>
        </StyledBreadcrumbWrapper>

        <Card title={title}>
          <FormTypology typology={typology} isUpdate onSubmit={onSubmitHandler} error={error} status={status} />
        </Card>
      </Wrapper>
    </div>
  );
};

export default TypologyPage;
